/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { GenerateRecordLocatorCommand } from "@/models/api/commands/booking/GenerateRecordLocatorCommand";
import { ChangeServiceTypeCommand } from "@/models/api/commands/booking/ChangeServiceTypeCommand";
import { ChangeSaleDateCommand } from "@/models/api/commands/booking/ChangeSaleDateCommand";
import { ChangePassengerNameCommand } from "@/models/api/commands/booking/ChangePassengerNameCommand";
import { ChangePassengerSurnameCommand } from "@/models/api/commands/booking/ChangePassengerSurnameCommand";
import { ChangeQuantityCommand } from "@/models/api/commands/booking/ChangeQuantityCommand";
import { ChangeCommentCommand } from "@/models/api/commands/booking/ChangeCommentCommand";
import { ChangeStatusCommand } from "@/models/api/commands/booking/ChangeStatusCommand";
import { CloneBookingItemCommand } from "@/models/api/commands/booking/CloneBookingItemCommand";
import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";
import { ChangeRecordLocatorCommand } from "@/models/api/commands/booking/ChangeRecordLocatorCommand";
import { ChangeGDSCommand } from "@/models/api/commands/booking/ChangeGDSCommand";
import { AddBookingItemCommand } from "@/models/api/commands/booking/AddBookingItemCommand";
import { RemoveBookingItemCommand } from "@/models/api/commands/booking/RemoveBookingItemCommand";
import { RefundBookingItemCommand } from "@/models/api/commands/booking/RefundBookingItemCommand";
import { ChangeCurrencyCommand } from "@/models/api/commands/booking/ChangeCurrencyCommand";
import { ChangeGrandTotalCommand } from "@/models/api/commands/booking/ChangeGrandTotalCommand";
import { ChangePurchaseNetPriceCommand } from "@/models/api/commands/booking/ChangePurchaseNetPriceCommand";
import { ChangePurchaseNetPriceInCurrencyCommand } from "@/models/api/commands/booking/ChangePurchaseNetPriceInCurrencyCommand";
import { ChangePurchaseNetPriceCurrencyCommand } from "@/models/api/commands/booking/ChangePurchaseNetPriceCurrencyCommand";
import { ChangePurchaseNetPriceExchangeDateCommand } from "@/models/api/commands/booking/ChangePurchaseNetPriceExchangeDateCommand";
import { ChangePurchaseNetPriceExchangeRateCommand } from "@/models/api/commands/booking/ChangePurchaseNetPriceExchangeRateCommand";
import { ChangeExchangeDateCommand } from "@/models/api/commands/booking/ChangeExchangeDateCommand";
import { ChangeExchangeRateCommand } from "@/models/api/commands/booking/ChangeExchangeRateCommand";
import { CopyAgentIdToAllBookingItemCommand } from "@/models/api/commands/booking/CopyAgentIdToAllBookingItemCommand";
import { ChangeHasCostDocumentCommand } from "@/models/api/commands/booking/ChangeHasCostDocumentCommand";
import { RemoveFileCommand } from "@/models/api/commands/booking/RemoveFileCommand";
import { CopyAttributeToAllBookingItemCommand } from "@/models/api/commands/booking/CopyAttributeToAllBookingItemCommand";
import { ChangeAttributeCommand } from "@/models/api/commands/booking/ChangeAttributeCommand";
import { GetAttributesCommand } from "@/models/api/commands/booking/GetAttributesCommand";
import { ChangeFileNameCommand } from "@/models/api/commands/booking/ChangeFileNameCommand";
import { AddAttributeCommand } from "@/models/api/commands/booking/AddAttributeCommand";
import { ChangeContractorCommand } from "@/models/api/commands/booking/ChangeContractorCommand";
import { Contractor } from "@/models/api/Contractor";
import { RemoveContractorCommand } from "@/models/api/commands/booking/RemoveContractorCommand";
import { BOOKING_STATUSES } from "@/static/bookingStatuses";
import { ChangeIsBlockedToInvoiceCommand } from "@/models/api/commands/booking/ChangeIsBlockedToInvoiceCommand";
import { ChangeAgentIdCommand } from "@/models/api/commands/booking/ChangeAgentIdCommand";
import { ChangeFirstNumberCommand } from "@/models/api/commands/booking/ChangeFirstNumberCommand";
import { ToggleCreateVoucherCommand } from "@/models/api/commands/booking/ToggleCreateVoucherCommand";
import { ChangeFareBaseCommand } from "@/models/api/commands/booking/ChangeFareBaseCommand";
import { ChangeGrandTotalInCurrencyCommand } from "@/models/api/commands/booking/ChangeGrandTotalInCurrencyCommand";
import { ConnectWithPreviousBookingCommand } from "@/models/api/commands/booking/ConnectWithPreviousBookingCommand";
import { UndoCommand } from "@/models/api/commands/booking/UndoCommand";
import { RedoCommand } from "@/models/api/commands/booking/RedoCommand";
import { SnackbarModel } from "@/models/components/popup/Snackbar";
import { waitAsync } from "@/utils/wait";
import { CopyGrandTotalToAllBookingItem } from "@/models/api/commands/booking/CopyGrandTotalToAllBookingItem";
import { CopyFareBaseToAllBookingItem } from "@/models/api/commands/booking/CopyFareBaseToAllBookingItem";
import { CopyPurchaseNetPriceToAllBookingItem } from "@/models/api/commands/booking/CopyPurchaseNetPriceToAllBookingItem";
import { AddBookingItemTradeTermCommand } from "@/models/api/commands/booking/AddBookingItemTradeTermCommand";
import { ChangeBookingItemTradeTermCommand } from "@/models/api/commands/booking/ChangeBookingItemTradeTermCommand";
import { TRADE_TERM_APPLY_TO } from "@/static/tradeTermApplyToTypes";
import { MESSAGE_TYPES } from "@/static/messageTypes";
import { CopyRequiredAttributesCommand } from "@/models/api/commands/booking/CopyRequiredAttributesCommand";
import { CopyGrandTotalExchangeRateToAllBookingItemCommand } from "@/models/api/commands/booking/CopyGrandTotalExchangeRateToAllBookingItemCommand";
import { CopyPurchaseNetPriceExchangeRateToAllBookingItemCommand } from "@/models/api/commands/booking/CopyPurchaseNetPriceExchangeRateToAllBookingItemCommand";
import { CopyCreationDateToAllBookingItems } from "@/models/api/commands/booking/CopyCreationDateToAllBookingItems";
import { ChangeContractorExportOrderBetweenOffice } from "@/models/api/commands/booking/ChangeContractorExportOrderBetweenOffice";
import { AddFilesCommand } from "@/models/api/commands/booking/AddFilesCommand";
import { ChangeCostDocumentNumberCommand } from "@/models/api/commands/booking/ChangeCostDocumentNumberCommand";
import { CopyCostDocumentNumberToAllBookingItemsCommand } from "@/models/api/commands/booking/CopyCostDocumentNumberToAllBookingItemsCommand";
import { ChangeIsFromBSPCommand } from "@/models/api/commands/booking/ChangeIsFromBSPCommand";
import { FORM_OF_PAYMENTS } from "@/static/formOfPayments";
import { ChangeFormOfPaymentCommand } from "@/models/api/commands/booking/ChangeFormOfPaymentCommand";
import { ChangeCreditCardCommand } from "@/models/api/commands/booking/ChangeCreditCardCommand";
import { CopyFormOfPaymentToAllBookingItemsCommand } from "@/models/api/commands/booking/CopyFormOfPaymentToAllBookingItemsCommand";
import { CopyHasCostDocumentFileToAllBookingItemsCommand } from "@/models/api/commands/booking/CopyHasCostDocumentFileToAllBookingItemsCommand";
import { ConfirmModel } from "@/models/components/popup/Confirm";
import { CALCULATE_ORDER_ITEM_VALUE } from "@/static/calculateOrderItemValueTypes";
import { CalculateFromValueCommand } from "@/models/api/commands/booking/CalculateFromValueCommand";
import { ChangeServiceTypeGroupCommand } from "@/models/api/commands/booking/ChangeServiceTypeGroupCommand";
import { CopyIsBlockedToInvoiceToAllBookingItemsCommand } from "@/models/api/commands/booking/CopyIsBlockedToInvoiceToAllBookingItemsCommand";
import PERMISSIONS from "@/static/permissions";
import { CopyQuantityToAllBookingItemsCommand } from "@/models/api/commands/booking/CopyQuantityToAllBookingItemsCommand";
import { ToggleFileSendWithInvoiceCommand } from "@/models/api/commands/booking/ToggleFileSendWithInvoiceCommand";
import { CopyCostDocumentKsefNumberToAllBookingItemsCommand } from "@/models/api/commands/booking/CopyCostDocumentKsefNumberToAllBookingItemsCommand";
import { ChangeCostDocumentKsefNumberCommand } from "@/models/api/commands/booking/ChangeCostDocumentKsefNumberCommand";

const BookingAddEditCommandsModule = defineModule({
  state: {},
  namespaced: true as const,
  getters: {},
  mutations: {},
  actions: {
    async generateRecordLocator(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new GenerateRecordLocatorCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async addFiles(context, params: { fileIds: Array<number>; type: number }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new AddFilesCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          params.fileIds,
          params.type
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeIsBlockedToInvoiced(context, isBlockedToInvoice: boolean) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeIsBlockedToInvoiceCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          isBlockedToInvoice
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeServiceTypeGroup(context, code: string | null) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeServiceTypeGroupCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          code as string
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeServiceType(context, serviceTypeId: number | null) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeServiceTypeCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          serviceTypeId as number
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeSaleDate(context, saleDate: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeSaleDateCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          saleDate
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async copyCreationDateToAllBookingItems(context, saleDate: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedCreationDateWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyCreationDateToAllBookingItems(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            saleDate
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async changeName(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangePassengerNameCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeSurname(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangePassengerSurnameCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeQuantity(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeQuantityCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseInt(value)
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeComment(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeCommentCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeFirstNumber(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeFirstNumberCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeFareBase(context, param: { value: string; isNet: boolean }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeFareBaseCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseFloat(param.value),
          param.isNet
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeCurrency(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeCurrencyCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeGrandTotal(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeGrandTotalCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseFloat(value)
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeGrandTotalInCurrency(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeGrandTotalInCurrencyCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseFloat(value)
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async connectWithPreviousBooking(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ConnectWithPreviousBookingCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changePurchaseNetPrice(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangePurchaseNetPriceCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseFloat(value)
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changePurchaseNetPriceInCurrency(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangePurchaseNetPriceInCurrencyCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseFloat(value)
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changePurchaseNetPriceCurrency(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangePurchaseNetPriceCurrencyCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changePurchaseNetPriceExchangeDate(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangePurchaseNetPriceExchangeDateCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changePurchaseNetPriceExchangeRate(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangePurchaseNetPriceExchangeRateCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseFloat(value)
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeExchangeDate(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeExchangeDateCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeExchangeRate(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeExchangeRateCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          parseFloat(value)
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeStatus(context, value: BOOKING_STATUSES) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        if (
          value == 2 &&
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.grandTotal == 0 &&
          !(await rootDispatch.popup.addConfirm(
            new ConfirmModel(
              filterCapitalize(i18n.t("grossPriceIsZeroAreYouSure")),
              filterCapitalize(i18n.t("warning")),
              [
                {
                  text: filterCapitalize(i18n.t("no")),
                  color: "warning",
                  value: false,
                  outlined: true,
                },
                {
                  text: filterCapitalize(i18n.t("yes")),
                  color: "warning",
                  value: true,
                },
              ],
              "450px"
            )
          ))
        ) {
          await rootDispatch.bookingAddEdit.getTemporaryBookingItem();
          return;
        }

        const command = new ChangeStatusCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeBookingItemStatus(context, param: { value: BOOKING_STATUSES; bookingItemTmpId: string }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeStatusCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          param.bookingItemTmpId,
          param.value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeRecordLocator(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeRecordLocatorCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeGDS(context, value: number) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeGDSCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeHasCostDocument(context, value: boolean) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeHasCostDocumentCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeIsFromBSP(context, value: boolean) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeIsFromBSPCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async cloneBookingItem(context, bookingItemId: string) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.currentBookingItemId !== bookingItemId) {
        rootCommit.bookingAddEdit.setBookingItemId(bookingItemId);
      } else {
        await rootDispatch.bookingAddEdit.validateBookingItemStatus();
        if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
          let result = null;
          if (!(await rootDispatch.user.hasPermission(PERMISSIONS.BookingsChainedClone))) result = false;
          else {
            result = (await rootDispatch.popup.addConfirm({
              title: filterCapitalize(i18n.t("warning")),
              content: filterCapitalize(i18n.t("isBookingShouldBeCloneChainedThatRunManually")),
              customButtons: [
                {
                  text: filterCapitalize(i18n.t("cancel")),
                  color: "warning",
                  value: null,
                },
                {
                  text: filterCapitalize(i18n.t("no")),
                  color: "warning",
                  outlined: true,
                  value: false,
                },
                {
                  text: filterCapitalize(i18n.t("yes")),
                  color: "warning",
                  value: true,
                },
              ],
            })) as boolean | null;
          }
          if (result !== null) {
            const command = new CloneBookingItemCommand(
              rootState.bookingAddEdit.sessionId,
              rootState.bookingAddEdit.operationId,
              bookingItemId,
              result
            );
            await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
          }
        }
      }
    },
    async changeAgentId(context, value: string | null) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeAgentIdCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async copyAgentIdToAllBookingItem(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedAgentWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyAgentIdToAllBookingItemCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.agentId as string
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyGrandTotalToAllBookingItem(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedGrandTotalWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyGrandTotalToAllBookingItem(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.grandTotalInCurrency as number,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.currency as string,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.grandTotal as number,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.exchangeDate as string | null,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.exchangeRate as number | null
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyFareBaseToAllBookingItem(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedGrandTotalWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyFareBaseToAllBookingItem(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.fareBase as number
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyPurchaseNetPriceToAllBookingItem(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedGrandTotalWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyPurchaseNetPriceToAllBookingItem(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPriceInCurrency as number,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPriceCurrency as string,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPrice as number,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPriceExchangeDate as string | null,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPriceExchangeRate as number | null
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyGrandTotalExchangeRateToAllBookingItem(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedExchangeRateWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyGrandTotalExchangeRateToAllBookingItemCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.currency as string,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.exchangeDate as string | null,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.exchangeRate as number | null
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyPurchaseNetPriceExchangeRateToAllBookingItem(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedExchangeRateWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyPurchaseNetPriceExchangeRateToAllBookingItemCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPriceCurrency as string,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPriceExchangeDate as string | null,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.purchaseNetPriceExchangeRate as number | null
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async addBookingItem(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      await rootDispatch.bookingAddEdit.validateBookingItemStatus();
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new AddBookingItemCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async removeBookingItem(context, bookingItemId: string) {
      const { rootCommit, rootDispatch, rootState } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (rootState.bookingAddEdit.currentBookingItemId !== bookingItemId) {
        rootCommit.bookingAddEdit.setBookingItemId(bookingItemId);
      } else {
        if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
          const command = new RemoveBookingItemCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            bookingItemId
          );
          if (rootState.bookingAddEdit.currentBookingItemId === bookingItemId) {
            rootCommit.bookingAddEdit.setBookingItemId(null);
          }
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async refundBookingItem(context, bookingItemId: string) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.currentBookingItemId !== bookingItemId) {
        rootCommit.bookingAddEdit.setBookingItemId(bookingItemId);
      } else {
        await rootDispatch.bookingAddEdit.validateBookingItemStatus();
        if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
          const command = new RefundBookingItemCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            bookingItemId
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async removeBookingFile(context, value: number) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new RemoveFileCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async copyAttributeToAllBookingItems(context, attributeTmpId: string): Promise<void> {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      await waitAsync(200);
      await rootDispatch.waitForCompleteAllRequests();
      const attribute = rootState.bookingAddEdit.bookingItemAttributes.find((v) => v.tmpId === attributeTmpId);
      if (typeof attribute === "undefined") {
        rootDispatch.popup.addSnackbar(new SnackbarModel(filterCapitalize(i18n.t("error")), "error"));
        return;
      }
      if (attribute.value === undefined || attribute.value === null || attribute.value === "") {
        await rootDispatch.popup.addAlert({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(
            i18n.t("enterAttributeValueToCopyAttributeToAnotherBookings", {
              attributeName: attribute.label,
            })
          ),
          type: MESSAGE_TYPES.Warning,
          referenceNumber: null,
        });
        return;
      }
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const confirmation = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("information")),
          content: filterCapitalize(i18n.t("overwriteCompletedItems?")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("cancel")),
              color: "warning",
              value: null,
            },
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean | null;
        if (confirmation !== null) {
          const command = new CopyAttributeToAllBookingItemCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
            attributeTmpId,
            confirmation
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async changeAttribute(context, param: { attributeTmpId: string; isPrintable: boolean; value: string }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeAttributeCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          {
            BookingItemTmpId: rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
            AttributeTmpId: param.attributeTmpId,
            IsPrintable: param.isPrintable,
            Value: param.value,
          }
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async getAttributes(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new GetAttributesCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async copyRequiredAttributes(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new CopyRequiredAttributesCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeFileName(context, param: { fileTmpId: number; newName: string }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeFileNameCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          param.fileTmpId,
          param.newName
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async addNewAttribute(context, param: { attributePrototypeId: number; value: string }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new AddAttributeCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          param.attributePrototypeId,
          param.value,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async addNewTradeTerm(
      context,
      param: {
        amount: number;
        isHidden: boolean;
        separateItem: boolean;
        serviceTypeCode: string | null;
        appliesTo: TRADE_TERM_APPLY_TO | null;
      }
    ) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new AddBookingItemTradeTermCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          param.amount,
          param.isHidden,
          param.separateItem,
          param.serviceTypeCode,
          param.appliesTo
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeTradeTerm(
      context,
      param: {
        tradeTermId: string;
        amount: number;
        isHidden: boolean;
        separateItem: boolean;
        serviceTypeCode: string | null;
        appliesTo: TRADE_TERM_APPLY_TO | null;
        isDeleted: boolean;
      }
    ) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeBookingItemTradeTermCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          param.tradeTermId,
          param.amount,
          param.isHidden,
          param.separateItem,
          param.serviceTypeCode,
          param.appliesTo,
          param.isDeleted
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeContractor(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (
        rootState.bookingAddEdit.sessionId !== null &&
        rootState.bookingAddEdit.operationId !== null &&
        rootState.bookingAddEdit.contractors !== null
      ) {
        const command = new ChangeContractorCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          {
            ImportedContractorId: rootState.bookingAddEdit.contractors.importedContractorId,
            City: rootState.bookingAddEdit.contractors.city,
            Country: rootState.bookingAddEdit.contractors.country,
            Surname: rootState.bookingAddEdit.contractors.surname,
            IsIndividual: rootState.bookingAddEdit.contractors.isIndividual,
            Name: rootState.bookingAddEdit.contractors.name,
            StreetAndNumber: rootState.bookingAddEdit.contractors.streetAndNumber,
            TIN: rootState.bookingAddEdit.contractors.tin,
            PostalCode: rootState.bookingAddEdit.contractors.postalCode,
            NationalBusinessRegistryNumber: rootState.bookingAddEdit.contractors.nationalBusinessRegistryNumber,
          }
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async removeContractor(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (
        rootState.bookingAddEdit.sessionId !== null &&
        rootState.bookingAddEdit.operationId !== null &&
        rootState.bookingAddEdit.contractors !== null
      ) {
        const command = new RemoveContractorCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async contractorSelect(context, param: Contractor) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (
        rootState.bookingAddEdit.sessionId !== null &&
        rootState.bookingAddEdit.operationId !== null &&
        rootState.bookingAddEdit.contractors !== null
      ) {
        const command = new ChangeContractorCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          {
            ImportedContractorId: param.id,
            City: null,
            Country: null,
            Surname: null,
            IsIndividual: param.isIndividual,
            Name: null,
            StreetAndNumber: null,
            TIN: null,
            PostalCode: null,
            NationalBusinessRegistryNumber: null,
          }
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async setContractorExportOrderBetweenOffice(context, value: boolean) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (
        rootState.bookingAddEdit.sessionId !== null &&
        rootState.bookingAddEdit.operationId !== null &&
        rootState.bookingAddEdit.contractors !== null
      ) {
        const command = new ChangeContractorExportOrderBetweenOffice(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async toggleCreateVoucher(context, bookingItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ToggleCreateVoucherCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          bookingItemId
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeCostDocumentNumber(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeCostDocumentNumberCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async copyCostDocumentNumberToAllBookingItems(context, costDocumentNumber: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedCostDocumentNumberWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyCostDocumentNumberToAllBookingItemsCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            costDocumentNumber
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async changeCostDocumentKsefNumber(context, value: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeCostDocumentKsefNumberCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async copyCostDocumentKsefNumberToAllBookingItems(context, costDocumentKsefNumber: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedCostDocumentNumberWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyCostDocumentKsefNumberToAllBookingItemsCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            costDocumentKsefNumber
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async changeFormOfPayment(context, value: FORM_OF_PAYMENTS | null) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeFormOfPaymentCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          value
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async changeCreditCard(context, params: { creditCardId: number | null; creditCardNumber: string }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ChangeCreditCardCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
          params.creditCardId,
          params.creditCardNumber
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async copyFormOfPaymentToAllBookingItems(context, value: FORM_OF_PAYMENTS) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("selectedFormOfPaymentWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyFormOfPaymentToAllBookingItemsCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
            value
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyHasCostDocumentFileToAllBookingItems(context, value: boolean) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("valueWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyHasCostDocumentFileToAllBookingItemsCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
            value
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyIsBlockedToInvoiceToAllBookingItems(context, value: boolean) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("valueWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyIsBlockedToInvoiceToAllBookingItemsCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
            value
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async copyQuantityToAllBookingItems(context, value: number) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const result = (await rootDispatch.popup.addConfirm({
          title: filterCapitalize(i18n.t("warning")),
          content: filterCapitalize(i18n.t("valueWillBeAssignedToAllBookingItemsExcludingClones")),
          customButtons: [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              outlined: true,
              value: false,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ],
        })) as boolean;
        if (result) {
          const command = new CopyQuantityToAllBookingItemsCommand(
            rootState.bookingAddEdit.sessionId,
            rootState.bookingAddEdit.operationId,
            value
          );
          await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
        }
      }
    },
    async toggleFileSendWithInvoice(context, fileTmpId: number) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new ToggleFileSendWithInvoiceCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          fileTmpId
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async calculateFromValue(context, param: { value: number; type: CALCULATE_ORDER_ITEM_VALUE }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new CalculateFromValueCommand(
          rootState.bookingAddEdit.sessionId,
          rootState.bookingAddEdit.operationId,
          {
            BookingItemTmpId: rootState.bookingAddEdit.bookingItems?.bookingItemTmp.tmpId as string,
            Value: param.value,
            CalculateType: param.type,
          }
        );
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async undo(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new UndoCommand(rootState.bookingAddEdit.sessionId, rootState.bookingAddEdit.operationId);
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
    async redo(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.bookingAddEdit.sessionId !== null && rootState.bookingAddEdit.operationId !== null) {
        const command = new RedoCommand(rootState.bookingAddEdit.sessionId, rootState.bookingAddEdit.operationId);
        await rootDispatch.bookingAddEdit.queryUpdateBookingTemporary(command);
      }
    },
  },
});

export default BookingAddEditCommandsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, BookingAddEditCommandsModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, BookingAddEditCommandsModule);
